import curatorSyncStatus from './curator-sync-status'
export default curatorSyncStatus
